exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .buxOMEY3iB5nMEHFp9qZa{padding:8px 10px;background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}html[dir] ._28P9iYhjUpWW3HIL9uKquV{margin-top:20px}._3sWXO256Cgiop9LCIJxC8y{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir] ._1XZUyKUP1r58An2XYiKHXj{background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}", ""]);
// Exports
exports.locals = {
	"container": "buxOMEY3iB5nMEHFp9qZa",
	"containerPadding": "_28P9iYhjUpWW3HIL9uKquV",
	"button": "_3sWXO256Cgiop9LCIJxC8y",
	"disabledButton": "_1XZUyKUP1r58An2XYiKHXj"
};